import { get, keyBy } from 'lodash';
import { computed, defineComponent, onMounted, ref, watch, } from '@vue/composition-api';
import { usePermission, useBuiltinPermissionList, usePageList, useRoles } from './utils';
import { PAGE_PERM_MAPPING, PAGE_PERMISSIONS, PermissionType, } from './constants';
import { permissionApi } from '@/services';
import { message } from 'ant-design-vue';
import { Org } from './RoleList';
const authFromMap = {
    datasource: '第三方鉴权',
    'custom-auth': '平台配置-运行时自定义鉴权',
};
export default defineComponent({
    name: 'CheckDefineAuth',
    model: {
        event: 'change',
        prop: 'showModal',
    },
    props: {
        projectId: {
            type: String,
            default: window.RUNTIME_CONFIGS?.projectId || '',
        },
        env: {
            type: String,
            default: 'dev',
        },
        showModal: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const userId = ref('');
        const permId = ref('');
        const pageId = ref('');
        const bizId = ref('');
        const permQ = ref('');
        const debugResult = ref(null);
        const debugging = ref(false);
        const { pageList: pages, fetchPageList: fetchPages } = usePageList(props.projectId, props.env);
        const { permissions, fetchPermissions } = usePermission(props.projectId);
        const { roles, fetchRoles } = useRoles(props.projectId);
        const builtinPagePerms = PAGE_PERMISSIONS.map(i => ({
            name: i,
            cname: get(PAGE_PERM_MAPPING, i),
        }));
        const { filterPermissions: builtinPerms, fetchBuiltinPermissionList, } = useBuiltinPermissionList(props.projectId);
        onMounted(async () => {
            await fetchPages();
            await fetchPermissions(props.env);
            await fetchBuiltinPermissionList(props.env);
            await fetchRoles(props.env);
        });
        const relatedPageList = computed(() => {
            if (!permId.value)
                return [];
            if (builtinPerms.value.some(x => x.name === permId.value))
                return [];
            const perm = permissions.value.find(x => x.name === permId.value);
            if (!perm)
                return pages.value;
            if (perm.type !== PermissionType.PAGE)
                return [];
            if (!perm.relatedPages)
                return pages.value;
            const related = perm.relatedPages.split(',');
            const result = pages.value.filter(x => related.includes(x.pageId));
            return result;
        });
        const debugBtnDisabled = computed(() => {
            //   if (!userId.value || !permId.value) return true;
            if (!permId.value)
                return true;
            if (relatedPageList.value.length && !pageId.value)
                return true;
            return false;
        });
        const filterBuiltinPerms = computed(() => {
            const arr = [...builtinPagePerms, ...builtinPerms.value];
            const result = arr.filter(x => [x.name, x.cname].join('\n').includes(permQ.value));
            return result;
        });
        const filterCustomPerms = computed(() => {
            const arr = [...permissions.value];
            const result = arr.filter(x => [x.name, x.cname].join('\n').includes(permQ.value));
            return result;
        });
        watch(() => relatedPageList.value.length, (newLen) => {
            if (!newLen)
                pageId.value = '';
        });
        watch(() => [userId.value, permId.value, pageId.value, bizId.value], () => (debugResult.value = null));
        return {
            userId,
            permId,
            pageId,
            bizId,
            relatedPageList,
            debugBtnDisabled,
            pages,
            permissions,
            builtinPagePerms,
            builtinPerms,
            debugResult,
            debugging,
            permQ,
            filterBuiltinPerms,
            filterCustomPerms,
            roles,
        };
    },
    render() {
        const debug = async () => {
            this.debugging = true;
            try {
                const result = await permissionApi.fetchPermissionView(this.projectId, this.value, this.permId, this.pageId);
                this.debugResult = result;
            }
            catch (error) {
                message.error('检测权限失败');
            }
            finally {
                this.debugging = false;
            }
        };
        const renderAuthFrom = () => {
            const authResultFrom = this.debugResult?.authResultFrom;
            if (!authResultFrom)
                return <span>无极</span>;
            return <span>{authFromMap[authResultFrom]}</span>;
        };
        const renderRoleList = () => (<div>
        {Object.keys(this.debugResult?.roleUserMap).length === 0 ? <a-empty /> : null}
        {Object.keys(this.debugResult?.roleUserMap).map((role) => {
                const usersNode = this.debugResult?.roleUserMap[role].map((item) => (item.userType === 'org'
                    ? <Org record={item}/>
                    : <span><a-tag> {item.userName} </a-tag></span>));
                const roleIdMap = keyBy(this.roles, 'name');
                const roleObj = roleIdMap[role];
                if (!roleObj)
                    return { ...role, label: role, name: role, cname: role };
                const isEmpty = this.debugResult?.roleUserMap[role].length === 0;
                return (<span>
              <a-popover title="角色成员" trigger="hover">
                <template slot="content">
                  {isEmpty
                        ? <a-empty />
                        : <div style="width:400px;max-height:200px;overflow:scroll">{usersNode}</div>}
                </template>
                <a href="javascript:;" style="margin-right:8px">
                  {roleObj.cname}
                </a>
              </a-popover>
            </span>);
            })}
      </div>);
        const renderDebugResult = () => {
            if (!this.debugResult)
                return <a-empty />;
            return (<a-form-model labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <a-form-model-item label="来源">
            {renderAuthFrom()}
          </a-form-model-item>
          <a-form-model-item label="相关角色">
            {renderRoleList()}
          </a-form-model-item>
        </a-form-model>);
        };
        return (<div>
        <a-modal title="检测权限" width={960} visible={this.showModal} onCancel={() => this.$emit('change', false)}>
          <span slot="footer">
            <a-button onClick={() => this.$emit('change', false)}>
              关闭
            </a-button>
          </span>
          <div style={'display:grid;grid-template-columns:1fr 1fr'}>
            <a-form-model label-col={{ span: 8 }} wrapperCol={{ span: 16 }}>
              <a-form-model-item label="权限">
                <a-select placeholder="请选择" v-model={this.permId} allow-clear show-search onSearch={(q) => (this.permQ = (q || '').toLowerCase())}>
                  <a-select-opt-group label="内置权限">
                    {this.filterBuiltinPerms.map(x => (<a-select-option key={x.name} value={x.name}>
                        {`${x.cname}(${x.name})`}
                      </a-select-option>))}
                  </a-select-opt-group>
                  <a-select-opt-group label="自定义权限">
                    {this.filterCustomPerms.map(x => (<a-select-option key={x.name} value={x.name}>
                        {`${x.cname}(${x.name})`}
                      </a-select-option>))}
                  </a-select-opt-group>
                </a-select>
              </a-form-model-item>
              {this.relatedPageList.length ? (<a-form-model-item label="相关页面">
                  <a-select v-model={this.pageId} allow-clear show-search filter-option={(q, option) => {
                    if (!q)
                        return true;
                    const page = this.relatedPageList.find(x => x.id === option.key);
                    const str = [page?.pageName, page?.pageId]
                        .filter(Boolean)
                        .join('\n')
                        .toLowerCase();
                    return str.includes(q.toLowerCase());
                }}>
                    {this.relatedPageList.map(x => (<a-select-option key={x.id} value={x.pageId}>
                        {x.pageName}
                      </a-select-option>))}
                  </a-select>
                </a-form-model-item>) : null}
              <a-form-model-item wrapperCol={{ offset: 8 }}>
                <a-button type="primary" disabled={this.debugBtnDisabled} onClick={debug}>
                  检测
                </a-button>
              </a-form-model-item>
            </a-form-model>
            <div>
              <a-spin spinning={this.debugging}>{renderDebugResult()}</a-spin>
            </div>
          </div>
        </a-modal>
      </div>);
    },
});
